import { gemmiciApiServiceClient } from "../gemmiciApiService/AxiosIntance";

export default {
  retrieveThemesByCategoryAPI() {
    return gemmiciApiServiceClient.get("theme_categories");
  },
  uploadPicture(picture) {
    return gemmiciApiServiceClient.post("post_picture", picture, {
      headers: {
        "Content-type": "multipart/form-data"
      }
    })
  }
};
